var attendance_counts_template = require('./attendance_counts.twig');

export class AttendanceCounts
{
    constructor(counts, config, outOffice, roomCapacity) {
        const layout = app.appData.layout;
        const speakerBgColor = layout.attendance.speaker_color !== undefined
            ? layout.attendance.speaker_color
            : 'transparent';
        const employeeBgColor = layout.attendance.employee_color !== undefined
            ? layout.attendance.employee_color
            : 'transparent';
        const roomCapacityNumClass = outOffice && Number(counts.total_attendee) >= roomCapacity
            ? 'text-danger'
            : '';

        this.dom = $(twig({
            data: attendance_counts_template
        }).render({
            counts: counts,
            meetingPhase: config.meetingPhase,
            shownCounts: layout['attendance'].counts[config.meetingPhase],
            eventTypeConfig: config.eventTypeConfig,
            speaker: app.appData.labels.speaker,
            speakerBgColor: speakerBgColor,
            employeeBgColor: employeeBgColor,
            outOffice: outOffice,
            roomCapacity: roomCapacity,
            roomCapacityNumClass: roomCapacityNumClass
        }));
    }
}
